








































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import clientUnitDepartamentForm from '@/components/client-units/client-unit-departament-form.vue';
import { toUpperCase } from '@/helpers/toUpperCase';

@Component({
  components: { clientUnitDepartamentForm, PermissionAuth },
})
export default class ClientUnitDepartaments extends BaseComponent {
  @Prop()
  public value: any[];
  @Prop({
    default: false,
  })
  public isEdit: boolean;

  public departamentFormIsEdit: boolean = false;
  public departamentFormOpen: boolean = false;
  public departamentItem: any = {};
  public headersDepartaments: any = [
    { text: 'Nome', value: 'nome' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public data: any[] = [];

  @Watch('value')
  public onChangeData(): void {
    const uuidv4 = require('uuid/v4');

    this.data = this.value.map((item) => {
      return {
        ...item,
        nome: item.nome ? toUpperCase(item.nome) : '',
        id: item.id || uuidv4(),
      };
    });
  }

  public openDepartamentForm(): void {
    this.departamentItem = {
      id: null,
      nome: '',
    };
    this.departamentFormOpen = true;
  }

  public departamentEdit(item: any): void {
    this.departamentItem = item;
    this.departamentFormOpen = true;
    this.departamentFormIsEdit = true;
  }

  public departamentDelete(item: any): void {
    const deleteItem = () => {
      const index = this.data.findIndex(
        (departament) => departament.id === item.id,
      );
      this.data.splice(index, 1);
      this.$emit('input', this.data);
    };

    this.dialog.show(
      'error',
      'Excluir Setor',
      'Tem certeza que deseja excluir este Setor?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public closeDepartamentForm(): void {
    this.departamentFormOpen = false;
    this.departamentFormIsEdit = false;
  }

  public saveDepartamentForm(payload: any): void {
    if (this.departamentFormIsEdit) {
      const index = this.data.findIndex(
        (departament) => departament.id === payload.id,
      );
      this.data.splice(index, 1);
    }
    this.data.push(payload);
    this.departamentFormOpen = false;
    this.departamentFormIsEdit = false;
    this.departamentItem = null;
    this.$emit('input', this.data);
  }
}
